import signup from './signup.json'
import signin from "./signin.json"
import profile from "./profile.json"

export { signup, signin, profile };
